import { Link } from "react-router-dom";
import { BUSINESS, HOURS } from "@/data/content";

const Footer = () => (
  <footer className="border-t border-teal-line bg-panel pb-28 lg:pb-0" data-testid="site-footer">
    <div className="mx-auto grid max-w-7xl gap-12 px-5 py-16 sm:px-8 lg:grid-cols-4">
      <div>
        <img src="/assets/logo.png" alt="Luxpress Detailing" className="h-9 w-auto" />
        <p className="mt-5 max-w-xs text-sm leading-relaxed text-chrome">
          Premium car detailing and paint protection. {BUSINESS.address}.
        </p>
      </div>
      <div>
        <p className="spec-label mb-4">Services</p>
        <ul className="space-y-2 text-sm text-chrome">
          <li><Link className="transition-colors duration-200 hover:text-mint" to="/pricing" data-testid="footer-link-pricing">Detailing Packages</Link></li>
          <li><Link className="transition-colors duration-200 hover:text-mint" to="/services/ceramic-coating" data-testid="footer-link-ceramic">Ceramic Coating</Link></li>
          <li><Link className="transition-colors duration-200 hover:text-mint" to="/services/paint-protection-film" data-testid="footer-link-ppf">PPF & Vinyl Wraps</Link></li>
          <li><Link className="transition-colors duration-200 hover:text-mint" to="/services" data-testid="footer-link-services">All Services</Link></li>
        </ul>
      </div>
      <div>
        <p className="spec-label mb-4">Studio</p>
        <ul className="space-y-2 text-sm text-chrome">
          <li><Link className="transition-colors duration-200 hover:text-mint" to="/gallery" data-testid="footer-link-gallery">Gallery</Link></li>
          <li><Link className="transition-colors duration-200 hover:text-mint" to="/about" data-testid="footer-link-about">About</Link></li>
          <li><Link className="transition-colors duration-200 hover:text-mint" to="/journal" data-testid="footer-link-journal">Journal</Link></li>
          <li><Link className="transition-colors duration-200 hover:text-mint" to="/contact" data-testid="footer-link-contact">Contact & Book</Link></li>
        </ul>
      </div>
      <div>
        <p className="spec-label mb-4">Hours — Open Daily</p>
        <ul className="space-y-1 font-mono text-xs text-chrome">
          {HOURS.slice(0, 2).map((h) => (
            <li key={h.day} className="flex justify-between gap-4"><span>{h.day}</span><span>{h.time}</span></li>
          ))}
          <li className="text-mint">Mon – Sun, {HOURS[0].time}</li>
        </ul>
        <a href={BUSINESS.phoneHref} data-testid="footer-phone" className="mt-4 block font-display text-xl font-bold text-white transition-colors duration-200 hover:text-mint">
          {BUSINESS.phoneDisplay}
        </a>
        <div className="mt-4 flex gap-5">
          {BUSINESS.socials.map((s) => (
            <a key={s.label} href={s.href} target="_blank" rel="noopener noreferrer" data-testid={`footer-social-${s.label.toLowerCase()}`} className="font-mono text-[11px] uppercase tracking-[0.18em] text-chrome transition-colors duration-200 hover:text-mint">
              {s.label}
            </a>
          ))}
        </div>
      </div>
    </div>
    <div className="border-t border-teal-line">
      <div className="mx-auto flex max-w-7xl flex-col gap-2 px-5 py-6 font-mono text-[11px] uppercase tracking-[0.18em] text-chrome/60 sm:flex-row sm:items-center sm:justify-between sm:px-8">
        <span>© {new Date().getFullYear()} Luxpress Detailing</span>
        <span>{BUSINESS.tagline}</span>
      </div>
    </div>
  </footer>
);

export default Footer;
